import React, { Component } from 'react';
import { StyleSheet, ActivityIndicator, ImageBackground, StatusBar, ScrollView, SafeAreaView, Text, View, TouchableOpacity } from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HTML from 'react-native-render-html';
import { removeUserToken } from '../../../redux/User/user.actions';
import AppFooter from '../../components/app-footer';
import AppHeader from '../../components/app-header';
import AuthenticationWrapper from '../../components/authentication-wrapper';
import ErrorModal from '../../components/error-modal';
import { appStyles, Colors, Flex, button, FontFamily, postExcerptTags, postExcerptClasses, postExcerptTagsDarkMode, Helpers } from '../../styles/appStyles';
import { helpers } from '../../utils/helpers';
import CustomImage from '../../components/custom-image';
import getImagePath from '../../utils/image-helper';
import ButtonGradient from '../../components/button-gradient';
import { DEVICE_WIDTH } from '../../components/custom-camera';
import ScrollContainerView from '../../components/scroll-container-view';
import DontStopReading from '../../components/dont-stop-reading';
import YesterdayDontStopReading from '../../components/yesterday-dont-stop-reading';
import apiHelpers from '../../utils/api-helpers';
import PostContent from '../../components/post-content';
import moment from 'moment';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Seo from '../../components/seo-meta';
import seoObj from '../../utils/seo-helper';

const healthcare = getImagePath('icons/healthcare.png');
const business = getImagePath('icons/business.png');
const covid = getImagePath('icons/covid-19.png');
const envoroment = getImagePath('icons/envoroment.png');
const markets = getImagePath('icons/markets.png');
const sports = getImagePath('icons/sports.png');
const world = getImagePath('icons/world.png');
const economy = getImagePath('icons/economy.png');
const choas = getImagePath('icons/choas.png');
const politics = getImagePath('icons/politics.png');

const facebook16 = getImagePath('icons/facebook16.png');
const link16 = getImagePath('icons/link16.png');
const twitter16 = getImagePath('icons/twitter16.png');
const linkedin16 = getImagePath('icons/linkedin16.png');
const profile = getImagePath('img/priya-profile.jpg');
const storyNameThumbnial = getImagePath('img/storyNameThumbnial.png');
const logo = getImagePath('img/logo.png');
const storyRegister1 = getImagePath('img/storyRegister1.png');
const storyRegister2 = getImagePath('img/storyRegister2.png');
const storyRegister3 = getImagePath('img/storyRegister3.png');
const archiveIStoryName = getImagePath('img/archiveIStoryName.png');

export class YesterdayStoryScreen extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const { isAuthenticated, fetchToken } = this.props.auth;
        let token = webView ? (process.browser ? (isAuthenticated ? fetchToken : false) : this.props.token) : this.props.user?.userData?.data?.token;


        this.state = {
            pageLoader: false,
            showErrorModal: false,
            showUparrow: false,
            footerData: this.props.footerData ? this.props.footerData : false,
            isUserLoggedIn: (token == undefined || token == '') ? false : true,
            locked_content: "<p><span class='firstletter'>I</span>f a bad penny were to acquire a name at this point in time, chances are it would settle for calling itself Gautam Singhania. Because Raymond, the iconic company Singhania inherited from his father, and of which he is chairman and managing director, is now perhaps in the most precarious position it has ever been in its 96-year history.</p> <p>Last year, several members of its senior management team, assiduously built over five years, quit. A replacement CEO for the lifestyle business put in his papers last month, after just seven months on the job. To think this happened at a time when the company had posted its biggest ever annual loss has given shareholders cause for concern. To add to their worries, Raymond’s valuation is down to Rs 2,600 crore, lesser than the value of 125 acres of land it holds in Mumbai’s suburbs. (A group company had sold 20 acres for Rs 700 crore in 2019.)</p> <p>Singhania, meanwhile, has been busy adding to his collection of vintage cars, a pursuit he seems</p>",
            isArchiveStory: false,
            token: token,
            storyData: this.props.postData?.data || this.props.history.location.state || false,
            seletedTab:0
        }
    }

    componentDidMount = () => {
        if(!this.state.storyData)
            this.YesterdayApiData()

    }

    YesterdayApiData = () => {
    
        const { token } = this.state;
        let endpoint = `/yesterday/editions/${this.props.postSlug}`;
        let body = {
            // "limit": 1,
            "sort_on": "published_date",
            "sort_by": "DESC",
            // "start_date": "13-11-2021",
            // "end_date": "13-11-2021",
            // "published_date": "14-11-2021", 
            "published_date": moment(new Date()).format("DD-MM-YYYY"),            
            // paged: 1,
        }
        apiHelpers
            .apiRequest(endpoint,
             body, "GET", true, token)
            .then((res) => {
                this.setState({
                    storyData:res.data
                })
            })
            .catch((error) => {
                console.log('Error=>> down', JSON.stringify(error));
            });
    }

    renderPageHeader = () => {
        return (
            <></>
        )
    }

    showPageLoader = () => {
        const webView = helpers.isWeb();
        return (
            <View style={[Flex.justfiyCenter, Flex.alignCenter,
            {
                position: webView ? 'fixed' : 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: '#ffffff',
            }]}
            >
                <ActivityIndicator size={25} color={'#000000'} />
            </View>
        )
    }

    renderReadMainStoryBanner = (darkMode) => {
        return (
            <View style={{ backgroundColor: "#ffffff", marginTop: 30 }}>
                <View style={[helpers.isDesktop() ? Flex.row : Flex.column, Flex.alignStart, Flex.justfiyCenter, Flex.FlexWrap, { maxWidth: helpers.isDesktop() ? "90%" : "100%", width: "100%", margin: "auto", marginTop: 0, marginBottom: 0 }]}>
                    <View style={[helpers.isDesktop() ? Flex.row : Flex.flexColumnReverse, Flex.alignStart, Flex.justfiyCenter, { maxWidth: helpers.isDesktop() ? "100%" : "100%", width: "100%", margin: "auto", padding: 20, paddingBottom: 0 }]}>
                        <View style={{ width: helpers.isDesktop() ? "70%" : "100%" }}>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 42 : 24, lineHeight: helpers.isDesktop() ? 50.4 : 31, fontFamily: FontFamily.abrilFatface, color: '#051462', paddingBottom: 15, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Read main story of that day
                            </Text>

                        </View>

                        <View style={[Flex.row, helpers.isDesktop() ? Flex.justifyEnd : Flex.justifyStart, { width: "20%" }]}>
                            <View style={{ width: helpers.isDesktop() ? 167 : 95.4, marginBottom: 10 }}>
                                <CustomImage
                                    source={logo}
                                    require={true}
                                    style={[helpers.isWeb() ? { width: helpers.isDesktop() ? 116 : 96, height: "auto" } : { width: helpers.isDesktop() ? 116 : 96, height: 30 }]}
                                    altText={'The Morning Context'}
                                />
                            </View >
                        </View>
                    </View>


                    <View style={[helpers.isDesktop() ? Flex.row : Flex.column, Flex.alignStart, { maxWidth: helpers.isDesktop() ? "90%" : "100%", width: helpers.isDesktop() ? "90%" : "100%", margin: "auto", marginTop: helpers.isDesktop() ? 30 : 10, marginBottom: 0 }]}>
                        <View style={{ padding: 20, width: helpers.isDesktop() ? "90%" : "100%", paddingTop: 0, }}>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 19 : 16, lineHeight: helpers.isDesktop() ? 22.8 : 19.5, fontFamily: FontFamily.medium, color: '#F7A34B', textTransform: "uppercase" }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                internet
                            </Text>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 30 : 22, lineHeight: helpers.isDesktop() ? 45 : 32.56, fontFamily: FontFamily.medium, color: '#000000' }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                How India is handling human to animal transmission of COVID-19 (or not)
                            </Text>
                            <ImageBackground style={[{ width: "100%", height: helpers.isDesktop() ? 168 : 114, margin: "auto", background: "#ccc" }]} source={archiveIStoryName} resizeMode="cover" >
                            </ImageBackground>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 30 : 27, lineHeight: helpers.isDesktop() ? 45 : 35, fontFamily: FontFamily.medium, color: '#000000' }, { paddingBottom: 3, marginTop: 10, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>

                            </Text>
                            <HTML
                                html={this.state.locked_content}
                                tagsStyles={postExcerptTags}
                                classesStyles={postExcerptClasses}
                                onLinkPress={(event, href, data) => this.props.openLink(href)}
                            />
                        </View>

                    </View>
                    <View style={[Flex.row, Flex.alignStart, Flex.justfiyCenter, { width: "100%" }]}>

                        <View style={[{ padding: 20, width: helpers.isDesktop() ? 200 : "100%" }]}>
                            <ButtonGradient
                                title={"LEARN MORE"}
                                rootStyle={{
                                    btnWrapper: [button.primaryGradient, { width: "100%", height: helpers.isDesktop() ? 60 : 40 }],
                                    btnText: [button.primaryGradientText, { fontSize: 16, fontWeight: '400', }]
                                }}
                                onClick={() => null}
                                darkMode={darkMode}
                            />
                        </View>

                    </View>
                </View >
            </View>
        )
    }
    renderReadStoryFreeBanner = (darkMode) => {
        return (
            <View style={helpers.isWeb() ? { position: "absolute", width: "100%", height: "20%", bottom: 0, left: 0, right: 0 } : { position: "absolute", width: "100%", height: "100%", top: 0, left: 20, right: 0 }}>
                <View style={{
                    shadowColor: '#ffffff',
                    shadowOffset: { width: 0, height: -22 },
                    shadowOpacity: 1,
                    shadowRadius: 200,
                    elevation: 5, position: "absolute", width: "100%", height: helpers.isDesktop() ? 240 : 200, bottom: 0, left: 0, textAlign: "center", backgroundColor: "#ffffff", padding: 20
                }}>
                    <Text style={[{ fontSize: helpers.isDesktop() ? 48 : 24, lineHeight: helpers.isDesktop() ? 64.75 : 31, fontFamily: FontFamily.abrilFatface, color: '#051462' }, { paddingTop: 3, paddingBottom: 3, textAlign: "center" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>Read the story for free</Text>

                    <Text style={[{ fontSize: helpers.isDesktop() ? 24 : 16, lineHeight: helpers.isDesktop() ? 36 : 23.75, fontFamily: FontFamily.regular, color: '#051462' }, { paddingBottom: 3, textAlign: "center" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>Sign up for Yesterday and let it help you catch up with the news</Text>
                    <View style={[Flex.row, Flex.alignStart, Flex.justfiyCenter,]}>

                        <View style={{ padding: 20, width: helpers.isDesktop() ? 200 : "100%", }}>
                            <ButtonGradient
                                title={"Sign up"}
                                rootStyle={{
                                    btnWrapper: [button.primaryGradient, { width: "100%", height: helpers.isDesktop() ? 60 : 40 }],
                                    btnText: [button.primaryGradientText, { fontSize: 16, fontWeight: '400', }]
                                }}
                                onClick={()=>this.props.navigateToScreen(`/sign-up?redirect=/&`)}
                                darkMode={darkMode}
                            />
                        </View>

                    </View>
                </View>

            </View>
        )
    }
    categoryImage=(category)=>{
        let image 
        if(category ==='Health')
           return image=healthcare
        if(category === "Business")
           return image =business
        if(category === "Choas")
            return image =Chaos
        if(category ==='Covid-19')
           return image=covid
        if(category === "Ecomony" || category === "Nation" )
           return image =economy
        if(category === "Markets")
            return image =markets
        if(category ==='Sports')
            return image=healthcare
        if(category === "World")
            return image =world
        if(category === "politics")
        return image =politics
    }
    renderPageContent = () => {
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        let { isUserLoggedIn, isArchiveStory,storyData ,seletedTab} = this.state
        let path = window.location.origin + window.location.pathname;
        return (
            
            <>
            {storyData?
                <View>                
                {/* </View><View style={[{ backgroundColor: "#F3F5FF", position: "relative", height: helpers.isDesktop() ? 1150 : 780, overflow: "hidden" }, { padding: helpers.isDesktop() ? 40 : 20, paddingTop: helpers.isDesktop() ? 0 : 20, paddingBottom: helpers.isDesktop() ? 0 : 20 }, darkMode && { backgroundColor: Colors.darkPurple }]}> */}

                <View style={[{ backgroundColor: "#F3F5FF", position: "relative", height: helpers.isDesktop() ? (isUserLoggedIn ? "auto" : 1180) : (isUserLoggedIn ? "auto" : 780), overflow: isUserLoggedIn ? "visible" : "hidden" }, { padding: helpers.isDesktop() ? 40 : 20, paddingTop: helpers.isDesktop() ? 0 : 20, paddingBottom: helpers.isDesktop() ? 0 : 20 }, darkMode && { backgroundColor: Colors.darkPurple }]}>


                    <View style={[helpers.isDesktop() ? Flex.row : Flex.column, Flex.alignCenter, Flex.justfiyCenter, { maxWidth: helpers.isDesktop() ? "90%" : "100%", width: "100%", margin: "auto", marginTop: 0, marginBottom: 0 }]}>
                        <View style={[{ width: helpers.isDesktop() ? "20%" : "100%", padding: 10 }]}>
                        </View>
                        <View style={[{ width: helpers.isDesktop() ? "70%" : "100%" }]}>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 21 : 23.5, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginTop: helpers.isDesktop() ? 34 : 10, marginBottom: helpers.isDesktop() ? 15 : 10 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Yesterday &gt; {moment(storyData?.published_date).format('DD MMMM YYYY')}
                            </Text>

                            <Text style={[{ fontSize: helpers.isDesktop() ? 48 : 27, lineHeight: helpers.isDesktop() ? 64.75 : 35, fontFamily: FontFamily.abrilFatface, color: '#051462' }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                 {ReactHtmlParser(storyData?.title)}                                
                            </Text>
                            <View style={[Flex.row, Flex.alignStar, { marginBottom: 20 }]}>
                            

                                <View style={[Flex.row, Flex.alignStart, { padding: 10, paddingLeft: 0, paddingRight: 20 }]}>
                                    {storyData && storyData.authors &&storyData?.authors.map((item,idx)=>{
                                        return(
                                            <>
                                            
                                    <View style={[Flex.alignCenter, Flex.justfiyCenter, Flex.row, { width: 24, height: 24, borderWidth: 1, borderColor: "#EF3C3B", borderRadius: 24, marginRight: helpers.isDesktop() ? 15 : 10, }]}>
                                    <TouchableOpacity onPress={()=>{
                                                window.open(`/writers/${item.slug}`,"_self")
                                                }}>
                                                <View style={{ width: 22.4, height: 22.4, borderWidth: 2, borderColor: "#ffffff", borderRadius: 24, overflow: "hidden" }}>
                                                    <CustomImage
                                                        resizeMode={'contain'}
                                                        source={item.image}
                                                        require={true}
                                                        style={[{ width: "100%", borderRadius: 24, height: "100%" }]}
                                                        altText={item.name}
                                                    />
                                                </View>
                                                </TouchableOpacity>

                                    </View> 
                                    <TouchableOpacity onPress={()=>{
                                                window.open(`/writers/${item.slug}`,"_self")
                                                }}>
                                    
                                    <View>

                                        <Text style={[{ fontSize: helpers.isDesktop() ? 16 : 15, lineHeight: helpers.isDesktop() ? 19.2 : 18, fontFamily: FontFamily.regular, color: '#000000' }, { textAlign: "left", marginBottom: 0 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                            {item.name} {" "}
                                        </Text>
                                    </View>
                                    </TouchableOpacity>
                                            </>
                                        )
                                    }) }
                                </View>
                                {/* <View style={[Flex.row, Flex.alignStart, { padding: 10, paddingLeft: 0, paddingRight: 10 }]}>
                                    <View style={[Flex.alignCenter, Flex.justfiyCenter, Flex.row, { width: 24, height: 24, borderWidth: 1, borderColor: "#EF3C3B", borderRadius: 24, marginRight: helpers.isDesktop() ? 15 : 10, }]}>
                                        <View style={{ width: 22.4, height: 22.4, borderWidth: 2, borderColor: "#ffffff", borderRadius: 24, overflow: "hidden" }}>
                                            <CustomImage
                                                resizeMode={'contain'}
                                                source={profile}
                                                require={true}
                                                style={[{ width: "100%", borderRadius: 24, height: "100%" }]}
                                                altText={'Have Only 5 Minutes'}
                                            />
                                        </View>

                                    </View>
                                    <View>
                                        <Text style={[{ fontSize: helpers.isDesktop() ? 16 : 15, lineHeight: helpers.isDesktop() ? 19.2 : 18, fontFamily: FontFamily.regular, color: '#000000' }, { textAlign: "left", marginBottom: 0 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                            Gaurangi Agarwal
                                        </Text>
                                        <Text style={[{ fontSize: helpers.isDesktop() ? 16 : 15, lineHeight: helpers.isDesktop() ? 19.2 : 18, fontFamily: FontFamily.light, color: '#000000' }, { textAlign: "left", marginBottom: helpers.isDesktop() ? 15 : 10 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                            Mumbai
                                        </Text>
                                    </View>
                                </View> */}

                            </View>

                        </View>
                    </View>
                    <View style={[helpers.isDesktop() ? Flex.row : Flex.column, Flex.alignStart, Flex.justfiyCenter, { maxWidth: helpers.isDesktop() ? "90%" : "100%", width: "100%", margin: "auto", marginTop: 0, marginBottom: helpers.isDesktop() ? 60 : 20 }]}>
                        {helpers.isDesktop() && 
                        <View style={[{ width: helpers.isDesktop() ? "20%" : "100%", padding: 10 }]}>
                            {storyData && storyData.posts && storyData.posts.map((item,index)=>{
                                return(
                                    <>
                                    {/* 6C7AF6 */}
                                    <TouchableOpacity 
                                    onPress={() => 
                                        {this.setState({ seletedTab: index})
                                        window.scroll(0,index*943);
                                    }}
                                    style={[{ marginBottom: 15, color:"#051462", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular  }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' },
                                    seletedTab == index && {borderLeftWidth: 2,fontFamily: FontFamily.bold,  borderColor: "#6C7AF6",color: '#907CFF'}
                                ]}>
                                {item.title}
                            </TouchableOpacity>
                            {/* <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Government curbs export of COVID-19 Rapid Antigen Testing kits
                            </TouchableOpacity>
                            <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Quick updates on what unfolded in Afghanistan
                            </TouchableOpacity>
                            <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Live-in relationship between man and married woman illegal: Rajasthan HC
                            </TouchableOpacity>
                            <TouchableOpacity style={[{ marginBottom: 15, borderLeftWidth: 2, borderColor: "#f3f5ff", paddingLeft: 10, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.regular, color: '#051462' }, { textAlign: "left", marginBottom: 15 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                TCS became the second Indian firm to cross ₹13 lakh crore in market value
                            </TouchableOpacity> */}
                            </>

                                )
                            }) 
                            }
                            <View style={{ width: "100%", height: 2, backgroundColor: "#DCD5FF", marginTop: 10, marginBottom: 10 }}></View>
                            <Text style={[{ fontSize: helpers.isDesktop() ? 16 : 16, lineHeight: helpers.isDesktop() ? 19.2 : 23.5, fontFamily: FontFamily.regular, color: '#000000' }, { textAlign: helpers.isDesktop() ? "left" : "center", marginBottom: helpers.isDesktop() ? 10 : 10 }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                Share
                            </Text>
                            <View style={[Flex.row]}>
                                <TouchableOpacity 
                                    onPress={()=>{
                                        window.open(
                                            `https://www.facebook.com/sharer/sharer.php?u=${path}&quote=${ReactHtmlParser(storyData.title)}`,
                                            "_blank"
                                          )
                                    }}
                                style={[{ marginBottom: 15, paddingLeft: 0, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.bold, color: '#907CFF' }, { textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                    <CustomImage
                                        source={facebook16}
                                        require={true}
                                        style={[{ width: 16, height: 16 }]}
                                        altText={'The Morning Context'}
                                    />
                                </TouchableOpacity>
                                <TouchableOpacity 
                                    onPress={()=>{
                                        window.open(
                                            // `https://twitter.com/intent/tweet?text=${storyData.title}&url=${path}`,
                                            `https://twitter.com/intent/tweet?text=${ReactHtmlParser(storyData.title)}&url=${path}`,

                                            "_blank"
                                          )
                                    }} 
                                    style={[{ marginBottom: 15, paddingLeft: 0, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.bold, color: '#907CFF' }, { textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                    <CustomImage
                                        source={twitter16}
                                        require={true}
                                        style={[{ width: 16, height: 16 }]}
                                        altText={'The Morning Context'}
                                    />
                                </TouchableOpacity>
                                <TouchableOpacity 
                                onPress={()=>{
                                    window.open(
                                        `https://www.linkedin.com/shareArticle?mini=true&url=${path}&summary=${ReactHtmlParser(storyData.title)}`,
                                        "_blank"
                                      )
                                }}style={[{ marginBottom: 15, paddingLeft: 0, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.bold, color: '#907CFF' }, { textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                    <CustomImage
                                        source={linkedin16}
                                        require={true}
                                        style={[{ width: 16, height: 16 }]}
                                        altText={'The Morning Context'}
                                    />
                                </TouchableOpacity>
                                <TouchableOpacity style={[{ marginBottom: 15, paddingLeft: 0, paddingRight: 10 }, { fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 20 : 23, fontFamily: FontFamily.bold, color: '#907CFF' }, { textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                    <CustomImage
                                        source={link16}
                                        require={true}
                                        style={[{ width: 16, height: 16 }]}
                                        altText={'The Morning Context'}
                                    />
                                </TouchableOpacity>

                            </View>
                        </View>
                        }
                        <View style={[{ width: helpers.isDesktop() ? "70%" : "100%" }]}>
                        {
                            storyData &&  storyData.posts && storyData.posts.map((item,index)=>{
                                return(
                            <View style={[helpers.isDesktop() && {
                                backgroundColor: "#F3F5FF"
                            }, { padding: helpers.isDesktop() ? 0 : 0, paddingBottom: 0, marginBottom: !isUserLoggedIn ? 20 : 20 }, darkMode && { backgroundColor: Colors.darkPurple },]}>
                                <View style={[helpers.isDesktop() && { backgroundColor: "#ffffff" }, { padding: helpers.isDesktop() ? 20 : 0, width: "100%", margin: "auto" }]}>
                                    <View style={[{ backgroundColor: "#ffffff" }, { padding: helpers.isDesktop() ? 20 : 10 }, darkMode && { backgroundColor: Colors.darkPurple }]}>
                                        <View style={[{ width: helpers.isDesktop() ? 116 : 96, marginBottom: 15 }]}>
                                            {item.category.map((value,index)=>{
                                                return(
                                                    <CustomImage
                                                source={this.categoryImage(value)

                                                }
                                                // source={healthcare}
                                                require={true}
                                                style={[helpers.isWeb() ? { width: helpers.isDesktop() ? 116 : 96, height: "auto" } : { width: helpers.isDesktop() ? 116 : 96, height: 30 }]}
                                                altText={'The Morning Context'}
                                            />
                                                )
                                            }) 
                                            }
                                        </View>
                                       
                                                    <View key={index}>
                                                    <Text style={[{ fontSize: helpers.isDesktop() ? 36 : 18, lineHeight: helpers.isDesktop() ? 39 : 26, fontFamily: FontFamily.bold, marginBottom: 15, color: '#051462' }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                                                            {item.title}
                                                    </Text>
                                                        {/* <CustomImage
                                                            source={item.featured_image}
                                                            require={true}
                                                            resizeMode={'cover'}
                                                            style={{ width: "100%", height: 200, backgroundColor: "red" }}
                                                            altText={'The Morning Context'}
                                                        /> */}
            
                                                    <Text style={[{ fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 36 : 23, fontFamily: FontFamily.regular, color: '#051462', marginTop: 10 }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>
                            <PostContent data={item.content} darkMode={darkMode} openLink={(link) => this.openSocialMedia(link)} />

                                                    </Text>
            
                                                </View>
                                    </View>

                                </View>
                            </View >
                                                )
                                            })
                                        }
                            {/* {isUserLoggedIn && <View style={[helpers.isDesktop() && {
                                backgroundColor: "#F3F5FF"
                            }, { padding: helpers.isDesktop() ? 0 : 0, paddingBottom: 0, marginBottom: !isUserLoggedIn ? 20 : 0 }, darkMode && { backgroundColor: Colors.darkPurple },]}>
                                <View style={[helpers.isDesktop() && { backgroundColor: "#ffffff" }, { padding: helpers.isDesktop() ? 20 : 0, width: "100%", margin: "auto" }]}>
                                    <View style={[{ backgroundColor: "#ffffff" }, { padding: helpers.isDesktop() ? 20 : 10 }, darkMode && { backgroundColor: Colors.darkPurple }]}>
                                        <View style={[{ width: helpers.isDesktop() ? 116 : 96, marginBottom: 15 }]}>
                                            <CustomImage
                                                source={healthcare}
                                                require={true}
                                                style={[helpers.isWeb() ? { width: helpers.isDesktop() ? 116 : 96, height: "auto" } : { width: helpers.isDesktop() ? 116 : 96, height: 30 }]}
                                                altText={'The Morning Context'}
                                            />
                                        </View>
                                        <View  >
                                            <Text style={[{ fontSize: helpers.isDesktop() ? 36 : 18, lineHeight: helpers.isDesktop() ? 39 : 26, fontFamily: FontFamily.bold, marginBottom: 15, color: '#051462' }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>New Zealand announced strict lockdown over one COVID-19 case second</Text>
                                            <CustomImage
                                                source={storyNameThumbnial}
                                                require={true}
                                                resizeMode={'cover'}
                                                style={{ width: "100%", height: 200, }}
                                                altText={'The Morning Context'}
                                            />

                                            <Text style={[{ fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 36 : 23, fontFamily: FontFamily.regular, color: '#051462', marginTop: 10 }, { paddingBottom: 3, textAlign: "left" }, darkMode && { color: 'rgba(255, 255, 255, 0.89)' }]}>The 63-year-old woman was infected with the Delta Plus variant of the virus, succumbing to it on July 27, said Brihanmumbai Municipal Corporation (BMC) officials. The authorities came to know only on August 11 that she was infected with the variant after her genome sequencing report was received. The woman tested positive on July 21 and had several comorbidities, including diabetes, according to officials. She was fully vaccinated and didn’t have any travel history. Two of her close contacts have also tested positive for the Delta Plus variant...
                                                Maharashtra has reported three deaths due to the Delta Plus variant so far.
                                            </Text>

                                        </View>
                                    </View>

                                </View>
                            </View >} */}
                        </View >
                    </View >

                    {!isUserLoggedIn && this.renderReadStoryFreeBanner(darkMode)}


                </View>

                {!isArchiveStory && isUserLoggedIn ?
                    <ScrollContainerView>
                        <YesterdayDontStopReading navigation={this.props.navigation} navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} />
                    </ScrollContainerView> : null}

                {isArchiveStory && isUserLoggedIn ? this.renderReadMainStoryBanner(darkMode) : null}
            </View >
       :
        <View style={[styles.container]}>
            <ActivityIndicator size="large" style = {styles.activityIndicator}/>          
        </View>  
       }

        </>

        )
    }

    renderWebPage = () => {
        return (
            <>
                {this.renderPageHeader()}
                {this.renderPageContent()}
            </>
        )
    }

    renderAppPage = () => {
        const { footerData } = this.state;
        return (
            <ScrollView>
                {this.renderPageHeader()}
                {this.renderPageContent()}
                <AppFooter navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} footerData={footerData} />
            </ScrollView>
        )
    }

    getSeoObject = () => {
        let { storyData } = this.state;
        if (storyData) {
            return seoObj.getYesterdayEditionSeo(storyData);
        }
        return {};
    }

    render() {
        const { pageLoader, showErrorModal,footerData,storyData } = this.state;
        const webView = helpers.isWeb();
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        let redirectSlugs = {
            web: '/',
            native: { redirect: '/', verifyRedirect: '/' }
        }
        return (
            <View style={[webView && { paddingTop: helpers.isDesktop() ? 54 : 56 }, appStyles.appBg, Flex.fill, darkMode && { backgroundColor: Colors.darkBlackColorBg }]}>
                {/* header : we will be new component for this module */}
                <Seo data={this.getSeoObject()} page="/yesterday/:slug" pageData={storyData} url={process.browser ? window.location.origin + window.location.pathname : ''} />

                <AppHeader ref="header" history={this.props.history} searchQuery={this.props.searchQuery} locationHash={this.props.locationHash} navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} redirectSlugs={redirectSlugs} refreshPage={() => this.setState({ subscriptionRefreshKey: !subscriptionRefreshKey })} setCredits={(credits) => this.setState({ credits: credits })} navigateToSubscriptionScreen darkMode={darkMode} showFullHeader={true} />
                {!showErrorModal && <>{pageLoader ? this.showPageLoader() :
                    (webView
                        ? this.renderWebPage()
                        : this.renderAppPage()
                    )
                }
                </>
                }
                <AppFooter navigateWeb={(slug) => this.props.navigateToScreen(slug)} navigateApp={(slug, params) => this.props.navigation.navigate(slug, params)} footerData={footerData} Breadcrumbs={Breadcrumbs}/>

                {showErrorModal && <ErrorModal goToHome={() => this.props.navigateToScreen('/')} tryAgain={() => this.getModalClickEvent()} show={showErrorModal} />}
            </View >
        );
    }
}

const mapStateToProps = (state) => {
    const { app, user } = state;
    return { app, user }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ removeUserToken }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationWrapper(YesterdayStoryScreen));


const customStyle = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: StatusBar.currentHeight,
    },
    scrollView: {
    },
    text: {
        fontSize: 42,
    },
});


let Breadcrumbs = [
    {
        name: 'Home',
        link: '/'
    },
    {
        name: 'Yesterday'
    }
]
const styles = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: "center"   
    },
    activityIndicator: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      height: 80
   }
  });